






























































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

const cssPrefix = 'sw-card-view';

@Component({
  components: {},
})
export default class SwCardView extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: Boolean, default: false })
  overlayHeader: boolean;

  @Prop({ type: Boolean, default: false })
  gradientHeader: boolean;

  @Prop({ type: Boolean, default: false })
  contentNoPadding: boolean;

  cssPrefix =  cssPrefix;
}
